import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_VOLUNTARY_PF);

const _pk_name = "id";

const state = {
  data:[],
  voluntaryPfEmployee: [],
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log('fetched data', state.data)
  },

  setVoluntaryPfEmployee: (state, payload) => {
    if(payload) {
      state.voluntaryPfEmployee = payload;
    }
    //console.log('fetched voluntaryPfEmployee', state.voluntaryPfEmployee)
  },

  addVoluntaryPfEmployee: (state, payload) => {
    //console.log('payload data from store', payload)
    state.voluntaryPfEmployee = payload;
    //console.log('voluntaryPfEmployee data', state.voluntaryPfEmployee);
    //console.log('state data', state.data);
  },

  updateVoluntaryPfEmployeeById: (state, payload) => {
    for(let i=0; i<state.data.length; i++) {
      if(state.data[i][_pk_name] === payload.id) {
        state.data.splice(i, 1, payload);
      }
    }
  },

  removeVoluntaryPfEmployeeById: (state, payload) => {
    for (let i=0; i<state.data.length; i++){
      if (state.data[i][_pk_name] == payload){
        state.data.splice(i, 1);
      }
    }
  },

  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}

const actions = {

async fetchVoluntaryPfEmployees({commit}, payload) {
  //console.log("[state/organisation/utility/voluntaryPfEmployee/fetchVoluntaryPfEmployees] Calling API...");
  //console.log('payload paygroup id', payload)
try {
  commit("setFetching", true);
  let res = await axios_instance.get(`/`, payload);
  commit("setFetching", false);
  //console.log("[state/organisation/utility/voluntaryPfEmployee/fetchVoluntaryPfEmployees] res: ", res);
  if(res.status == 200) {
    commit("setVoluntaryPfEmployee", res.data.rows);
  }
  return res;
}catch {

}
},

  async create({commit}, payload) {
      //console.log("[state/organisation/utility/voluntaryPfEmployee/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/organisation/utility/voluntaryPfEmployee/create] res: ", res);
      if(res.status == 200) {
        commit("addVoluntaryPfEmployee", payload);
      }
      return res;
    }catch(err) {
      //console.log(err)
    }
  },

  async update({commit}, payload) {
      //console.log("[state/organisation/utility/voluntaryPfEmployee/update] Updating... Display payload", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.put(`/`, payload);
      commit("setSaving", false);
      //console.log("[state/organisation/utility/voluntaryPfEmployee/update] res: ", res);
      if(res.status == 200) {
        commit("updateVoluntaryPfEmployeeById", res.data);
      }
      return res;
    }catch {

    }
  },

  async delete({commit}, payload) {
    //console.log("[state/organisation/utility/voluntaryPfEmployee/delete] Payload:", payload);
    //console.log("[state/organisation/utility/voluntaryPfEmployee/delete] Payload:", `/${payload.id}`);
    try {
      commit("setDeleting", true);
      let res = await axios_instance.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status == 200){
        commit("removeVoluntaryPfEmployeeById", payload.id);
      }
    }catch {

    }
  }
}

export default {
  namespaced: true,
  state, mutations, actions
}
